import { Container, Row, Col } from 'react-bootstrap';

export default function SupportFooter() {
  return (
    <footer className="mt-auto py-4" style={{ 
      backgroundColor: '#f8f9fa',
      borderTop: '1px solid #dee2e6',
      marginTop: '4rem'
    }}>
      <Container>
        <Row className="align-items-center">
          <Col md={6}>
            <p className="mb-0 text-muted">
              © 2025 Headliners. All rights reserved.
            </p>
          </Col>
          <Col md={6} className="text-md-end">
            <p className="mb-0">
              <span className="text-muted me-2">Need help?</span>
              <a 
                href="mailto:support@headlinefeed.dev" 
                className="text-primary text-decoration-none fw-medium"
              >
                📧 support@headlinefeed.dev
              </a>
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}
